export const AV_PANEL_WIDTH = 460;
export const AV_PANEL_COLOR = "#06709B";
export const AV_FAB_SIZE = 56;
export const AV_TRANSITION_MS = 340;
export const AV_HEADER_HEIGHT = 70;
export const AV_EXCLUDED_SEGMENTS = ["askvivo", "alerts", "insights"] as const;
export const AV_DEFAULT_QUESTIONS_COUNT = 3;
export const AV_VIEW_CHAT = "chat";
export const AV_VIEW_HISTORY = "history";
export const AV_VIEW_ALERT = "alert";
export const AV_VIEW_INSIGHT = "insight";
export const AV_CONTROL_BUTTON_SIZE = 24;
export const AV_CONTROL_ICON_SIZE = 16;
export const AV_BORDER_LIGHT = "#E5E7EB";
export const AV_TEXT_DARK = "#20353E";
export const AV_HISTORY_ROW_ACTIVE_BG = "#0000000f";
export const AV_HISTORY_ROW_TEXT = "#070B0D";
export const AV_HISTORY_DELETE_ICON = "#556C75";
export const AV_HISTORY_SEARCH_ICON = "#8097A0";
export const AV_HISTORY_CONFIRM_TEXT = "#064C68";
export const AV_DATE_TEXT = "#2B4752";
export const AV_HISTORY_BUTTON_BG = "#D2EFF9";
export const AV_DELETE_COLOR = "#CC0404";
export const AV_ERROR_TEXT = "#73134A";
export const AV_ERROR_DESCRIPTION_TEXT = "#260618";
